import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { OneSettingT, UpdateSettingT } from 'shared/api/types/services';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Update
export type UpdateFormT = UpdateSettingT['request'];
export const getUpdateValues = (values?: OneSettingT['response']): UpdateFormT => ({
  key: values?.key,
  description: values?.description,
  value: values?.value,
});
const updateSchema: Yup.ObjectSchema<UpdateFormT> = Yup.object({
  key: Yup.string().required(),
  description: Yup.string().required(),
  value: Yup.string().required(),
});
export const updateResolver = yupResolver(updateSchema) as Resolver<UpdateFormT>;
